var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraphLineUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.875 17.75v4.688h15.436L43.188 42.56 33.126 32.499a2.344 2.344 0 00-3.314 0L5.687 56.623l3.315 3.315L31.469 37.47 41.53 47.532a2.344 2.344 0 003.313 0l21.781-21.78v15.436h4.688V17.75H47.874z",
    fill: "#2E5ECC"
  })));
}

export default SvgGraphLineUp;